<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <kt-row id="pardakht-shakhsi-info">
                    <kt-col xs="12" md="6">
                        <ps-info
                                v-if="status !== 'loading'"
                                :form_data="form_data"
                        ></ps-info>
                    </kt-col>
                    <kt-col xs="12" md="6" id="setting_col">
                        <ps-setting></ps-setting>
                    </kt-col>
                </kt-row>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import { mapGetters } from 'vuex'
import info from './components/info'
import setting from './components/setting'

export default {
    components: {
        mainContent,
        'ps-setting': setting,
        'ps-info': info,
    },
    computed: {
        ...mapGetters('pardakhtShakhsi', [
            'form_data', 'status'
        ]),
    },
    data() {
        return {
            'hashid': this.$route.params.hashid
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('pardakhtShakhsi/find', vm.hashid)
        })
    },
}
</script>

<style>
    @media (min-width: 768px) {
        #gateway-info > div > :first-child {
            border-left: 1px solid #ddd;
        }
    }
</style>